// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2DUFs","root":"XHcEE","close":"_3hHEH","closeIcon":"O9o11"};